import { jsx as _jsx, jsxs as _jsxs } from 'react/jsx-runtime.js';
import { useEffect } from 'react';
import { Divider, Flex, TextLink } from '@stepstone-genesis/components';
import { useTranslation } from '@stepstone-platform/i18n';
import { ContentHeading } from '../../components/common/ContentHeading/index.js';
import { loginSourceSelector } from '../../redux/core/sourceData/sourceDataSlice.js';
import { TwoStepConsent } from '../../components/TwoStepConsent/index.js';
import { EmailInputWithButton } from './components/EmailInputWithButton.js';
import { SocialButtonsContainer } from './components/SocialButtonsContainer.js';
import { useAppSelector } from '../../redux/hooks.js';
import { useTranslatedSourceOverrideLabel } from '../../helpers/useTranslatedLabel.js';
import { loginRecruiterUrlSelector } from '../../redux/core/siteConfig/siteConfigSlice.js';
import { LoginAlert } from './components/LoginAlert.js';
import { useTrack } from '../../tracking/common/hooks/useTrack.js';
export const AccountIdentifier = () => {
    const { t } = useTranslation();
    const loginSource = useAppSelector(loginSourceSelector);
    const loginRecruiterUrl = useAppSelector(loginRecruiterUrlSelector);
    const useSourceOverrideLabel = useTranslatedSourceOverrideLabel(loginSource, t);
    const { trackBtnClick, trackModalComponentVisible } = useTrack('twoStep');
    const onAreYouRecruiter = () => {
        trackBtnClick({ uniqueName: 'switchToRecruiter' });
    };
    useEffect(() => {
        trackModalComponentVisible();
    }, []);
    const headerLabel = useSourceOverrideLabel('twoStepLoginRegistration.accountIdentifier.header');
    return (_jsxs(Flex, { flxDirection: 'column', gap: 'spaceL', "data-testid": "two-step-form", children: [_jsx(LoginAlert, {}), _jsx(ContentHeading, { label: headerLabel }), _jsx(EmailInputWithButton, {}), _jsx(SocialButtonsContainer, {}), _jsx(TwoStepConsent, { label: t('loginregistration.twoStepLoginRegistration.accountIdentifier.legalNote'), variant: "email-address" }), _jsx(Divider, {}), _jsx(Flex, { flxJustify: 'center', children: _jsx(TextLink, { "data-testid": "recruiter-login-link", variant: "bare", href: loginRecruiterUrl, target: '_self', onClick: onAreYouRecruiter, sx: {
                        lineHeight: 'lineHeightS',
                        fontFamily: 'fontFamilyPrimary',
                        fontSize: 'fontSizeM',
                        fontWeight: 'fontWeightNormal',
                    }, children: t('loginregistration.twoStepLoginRegistration.recruiterSignIn') }, "recruiterLink") })] }));
};
//# sourceMappingURL=AccountIdentifier.js.map